<template>
	<div class="btn-group print-button-group" role="group">
		<button
			type="button"
			@click="setValue(true)"
			:class="{'btn-info': value === true || value === '1' || value === 1}"
			:disabled="disabled"
			class="btn btn-default btn-sm"
		>
			{{ _traducao('global', 'sim') }}
		</button>
		<button
			type="button"
			@click="setValue(false)"
			:class="{'btn-info': value === false || value === '0' || value === 0}"
			:disabled="disabled"
			class="btn btn-default btn-sm"
		>
			{{ _traducao('global', 'nao') }}
		</button>
	</div>
</template>
<script>
export default {
	props: {
		value: {
			type: [Boolean, Number, String],
			required: false
		},

		disabled: {
			type: Boolean,
			default: false
		}
	},
	methods: {
		setValue(valor) {
			this.$emit('input', valor)
			this.$emit('change', valor)
		}
	}
}
</script>
